module.exports = __webpack_public_path__ + "static/img/icon_a.a6c0ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_a.png
// module id = 656
// module chunks = 2